import { HttpEventType } from '@angular/common/http';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ElementRef, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WhatsappTemplateService } from 'src/app/private/services/whatsapp-tempate.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AiTemplateService } from 'src/app/private/services/ai-template.service';

@Component({
  selector: 'app-creatae-whatsapp-template',
  templateUrl: './creatae-whatsapp-template.component.html',
  styleUrls: ['./creatae-whatsapp-template.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreataeWhatsappTemplateComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('editorElement') editorElement!: ElementRef;
  
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();

  @Input() type: string = 'Create';
  @Input() templateDataToEdit: any;
  uploadProgress: number = 0;
  isProcessingMedia = false;

  btnLoading = false;
  template: any = {
    template_name: '',
    header_text: '',
    category: '',
    language: '',
    labels: '',
    header: 'none',
    body: '',
    footer: '',
    media: '',
    mediaData: ''
  };
  languages: string[] = ['English', 'Hindi', 'Gujarati'];
  isSubmitted = false;
  editorData = '';
  currentTime!: string;
  public variableCounter: number = 0;
  private timerId: any;

  countQuickReplyButton: number = 0;
  countCTAButtonForURL: number = 0;
  countCTAButtonForCall: number = 0;

  quickReplyButtons: any[] = [];
  urlButtons: any[] = [];
  callButtons: any[] = [];
  languagesList: any[] = [];

  appId: any;
  token: any;

  variables: { [key: string]: string } = {}; // Object to hold variables and their sample values
  variableNames: { [key: string]: string } = {}; // Object to hold variables and their sample values
  renderedData: any = '';
  variableNameError: boolean = false;
  showAllVariables = false;
  fileName: string = '';
  fileType: string = '';
  base64Data: string = '';
  initiaBody: boolean = false;
  templateData: any;

  templateIDToEdit: any;
  mediaId: string = '';
  suffix: string = '';
  showMediaThroughMediaID: boolean = false;
  variableError: boolean = false;
  
  // Format state tracking
  boldActive: boolean = false;
  italicActive: boolean = false;
  strikethroughActive: boolean = false;

  // Saved cursor position for variable insertion
  private savedRange: Range | null = null;

  // AI Generation
  isGeneratingAI = false;
  aiGeneratePrompt = '';
  aiModalRef: NgbModalRef | null = null;
  
  allowedFields: string[] = [
    'name', 'email', 'phone'
  ];
  constructor(
    private toastr: ToastrService,
    private api: WhatsappTemplateService,
    private localStorage: LocalStorageService,
    private modalService: NgbModal,
    private aiService: AiTemplateService
  ) { }

  isMobile = false;
  openPreview = false;
  togglePreview() {
    this.openPreview = !this.openPreview;
  }


  ngOnInit() {
    this.isMobile = window.innerWidth <= 1024;
    this.updateTime();
    this.timerId = setInterval(() => this.updateTime(), 60000); // Update every minute
    this.getAllLanguages();

    setTimeout(() => {
      if (this.type === 'Edit') {
        this.templateData = this.templateDataToEdit;
        this.templateDataToEdit = this.templateDataToEdit.template_data;


        const { header, body, footer } = this.splitString(this.templateDataToEdit.containerMeta);

        const { quickReplyButtons, urlButtons, callButtons } = this.parseButtons(this.templateDataToEdit.containerMeta);

        this.quickReplyButtons = quickReplyButtons.map((button: string) => ({ value: button }));

        this.urlButtons = urlButtons.map((button: any) => ({ title: button.text, urlType: button.urlType, value: button.url, suffix: button.suffix }));

        this.callButtons = callButtons.map((button: any) => ({ title: button.text, value: button.url }));

        this.countQuickReplyButton = this.quickReplyButtons.length;

        this.countCTAButtonForURL = this.urlButtons.length;

        this.countCTAButtonForCall = this.callButtons.length;




        this.template = {
          template_name: this.templateDataToEdit.elementName,
          header_text: header,
          category: this.templateDataToEdit.category,
          labels: this.templateDataToEdit.vertical,
          body: body,
          footer: footer,
          header: (header === '' || header === undefined) ? 'none' : 'text',
          language: this.templateDataToEdit.languageCode,


        };


        this.templateIDToEdit = this.templateDataToEdit.id;

        this.editorData = this.formateData(this.template.body);;
        this.initiaBody = true;
        this.renderedData = this.formateData(this.editorData);
        
        // Update editor with template data
        if (this.editorElement) {
          this.editorElement.nativeElement.innerHTML = this.editorData;
        }

        const metaData = JSON.parse(this.templateDataToEdit.containerMeta);

        // Populate variableNames if exists
        let incomingVars = null;
        if (this.templateDataToEdit.variables) {
          incomingVars = this.templateDataToEdit.variables;
        } else if (this.templateData && this.templateData.variables) {
          incomingVars = this.templateData.variables;
        }

        if (incomingVars) {
          console.log('Found variables in edit data:', incomingVars);
          this.variableNames = typeof incomingVars === 'string'
            ? JSON.parse(incomingVars)
            : incomingVars;
        } else {
          console.log('No variables found in edit data', this.templateDataToEdit, this.templateData);
        }

        if (this.templateDataToEdit.templateType === 'IMAGE' || this.templateDataToEdit.templateType === 'VIDEO' || this.templateDataToEdit.templateType === 'DOCUMENT') {

          this.template.header = 'media';
          this.template.media = this.templateDataToEdit.templateType === 'IMAGE' ? 'image' : this.templateDataToEdit.templateType === 'VIDEO' ? 'video' : 'document';
          const data = JSON.parse(this.templateDataToEdit.meta);
          this.mediaId = data.mediaId;
          this.showMediaThroughMediaID = true;
        }

        if (metaData.sampleText) {

          const variablePattern = /\{\{\d+\}\}/g;
          const variablesInText = this.editorData.match(variablePattern);

          if (variablesInText) {
            const uniqueVariables = new Set(variablesInText);
            const variablesArray = Array.from(uniqueVariables);

            if (uniqueVariables.size < this.variableCounter) {
              let start = 1;

              // Loop through and replace all variables sequentially
              variablesArray.forEach((variable) => {
                const escapedVariable = variable.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special chars
                const variablePattern = new RegExp(escapedVariable, 'g');
                this.editorData = this.editorData.replace(variablePattern, `{{${start}}}`);
                start++;
              });

              // Update the variable counter
              this.variableCounter = start - 1;
            } else {
              this.variableCounter = uniqueVariables.size;
            }
          }

          this.extractVariables();

          this.variables = this.extractAndPopulate(metaData.sampleText);
          this.renderedData = this.removeBrackets(metaData.sampleText);
        }
      }
    }, 1000);
  }

  extractAndPopulate(inputString: string): { [key: string]: string } {
    const matches = inputString.match(/\[([^\]]+)\]/g);
    const result: { [key: string]: string } = {};

    if (matches) {
      matches.forEach((match, index) => {
        result[`{{${index + 1}}}`] = match.replace(/[\[\]]/g, '');  // Remove brackets and assign
      });
    }

    return result;
  }

  removeBrackets(input: string): string {
    let output = input.replace(/\*(.*?)\*/g, '<b>$1</b>');

    // Step 2: Remove square brackets [] but keep the content inside
    output = output.replace(/\[(.*?)\]/g, '$1');

    return output;
  }

  formateData(data: any) {
    return data
      .replace(/\n/g, '<br>')
      .replace(/\*(.*?)\*/g, '<b>$1</b>')
      .replace(/_(.*?)_/g, '<em>$1</em>')
      .replace(/~(.*?)~/g, '<s>$1</s>');
  }
  formatForApi(text: string): string {
    if (!text) return '';

    return text
      .replace(/<br\s*\/?>/gi, '\n') // safety
      .replace(/&amp;/g, '&')
      .replace(/\r/g, '')
      .trim();
  }
  splitString(inputString: any) {

    const inputData = JSON.parse(inputString);

    const { header, data: body, footer } = inputData;

    return {
      header: header,
      body: body,
      footer: footer
    };
  }

  parseButtons(input: string): {
    quickReplyButtons: string[], urlButtons: { text: string, urlType: string, url: string }[],
    callButtons: { text: string, url: string }[]
  } {
    const quickReplyButtons: string[] = [];
    const urlButtons: {
      text: string, urlType: string, url: string,
      suffix?: string
    }[] = [];
    const callButtons: { text: string, url: string }[] = [];

    // Parse the input string as JSON
    const inputData = JSON.parse(input);

    // Assuming buttons field is present in the input JSON
    const { buttons } = inputData;


    if (buttons) {
      buttons.forEach((button: any) => {
        if (button.type === 'QUICK_REPLY') {
          // Add to quickReplyButtons if type is QUICK_REPLY
          quickReplyButtons.push(button.text.trim());
        } else if (button.type === 'URL') {
          // Add to urlButtons if type is URL

          if (button.url.includes('{{1}}')) {
            const url = button.url.split('{{1}}');
            const suffix = button.example[0].split("/")[3];
            urlButtons.push({ text: button.text.trim(), urlType: "dynamic", url: url[0].trim(), suffix: suffix });
          } else {
            urlButtons.push({ text: button.text.trim(), urlType: "static", url: button.url.trim() });
          }
        } else if (button.type === 'PHONE_NUMBER') {
          // Add to urlButtons if type is URL
          callButtons.push({ text: button.text, url: button.phone_number });
        }
      });
    }

    return { quickReplyButtons, urlButtons, callButtons };
  }



  getAllLanguages() {
    // this.api.getAllLanguages().subscribe((res: any) => {
    //   this.languagesList = res;
    // });
      this.languagesList = [
      {
        "id": "1",
        "code": "en",
        "language": "English",
        "createdAt": "2024-09-10T12:07:50.696Z",
        "updatedAt": "2024-09-10T12:07:50.696Z"
      }
      // {
      //   "id": "2",
      //   "code": "hi",
      //   "language": "Hindi",
      //   "createdAt": "2024-09-10T12:08:24.237Z",
      //   "updatedAt": "2024-09-10T12:08:24.237Z"
      // }
    ];
  }

  storeAppId() {
    const payload = {
      hospital_id: this.localStorage.getHospitalId()
    };
    this.api.getAppId(payload).subscribe((res: any) => {
      this.appId = res.app_id;
      this.token = res.app_token;

    });
  }


  ngOnDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }

  ngAfterViewInit() {
    // For Create mode, initialize empty editor
    if (this.type !== 'Edit' && this.editorElement) {
      this.editorElement.nativeElement.innerHTML = '';
      this.updateFormattingState();
    }
    // For Edit mode, the editor is populated in ngOnInit's setTimeout
  }

  updateFormattingState(): void {
    this.boldActive = document.queryCommandState('bold');
    this.italicActive = document.queryCommandState('italic');
    try {
      this.strikethroughActive = document.queryCommandState('strikeThrough');
    } catch (e) {
      this.strikethroughActive = false;
    }
  }

  updateTime() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert 24-hour to 12-hour format
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    this.currentTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
  }

  onSubmit() {
    console.log('variableNames:', this.variableNames);
    this.isSubmitted = true;

    if (this.isValidForm()) {
      this.btnLoading = true;
      let modifyButtons: any = [];

      this.quickReplyButtons.forEach((button: any) => {
        modifyButtons.push({
          type: 'QUICK_REPLY',
          text: button.value
        });
      });

      this.urlButtons.forEach((button: any) => {


        if (button.urlType === 'static') {
          modifyButtons.push({
            type: 'URL',
            text: button.title,
            url: button.value
          });
        } else if (button.urlType === 'dynamic') {


          // {"type":"URL","text":"visit us","url":"https://gravitas.ai/{{1}}","example":["https://gravitas.ai/about"]}

          modifyButtons.push({
            type: 'URL',
            text: button.title,
            url: button.value + '{{1}}',
            example: [button.value + button.suffix]
          });
        }

      });

      this.callButtons.forEach((button: any) => {
        modifyButtons.push({
          type: 'PHONE_NUMBER',
          text: button.title,
          phone_number: button.value
        });
      });

      let exampleData = this.editorData;


      for (const variable in this.variables) {
        const value = this.variables[variable] || ''; // Use empty string if no value is provided

        const escapedVariable = variable.replace(/[{}]/g, '\\$&'); // Escape the curly braces
        const regex = new RegExp(escapedVariable, 'g'); // Create a global regular expression
        exampleData = this.renderedData.replace(regex, `[${value}]`);
      }



      const payload = {
        hospital_id: this.localStorage.getHospitalId(),
        user_id: this.localStorage.getUserId(),
        elementName: this.template.template_name,
        languageCode: this.template.language,
        category: this.template.category,
        template_id: this.templateIDToEdit,
        // for media hve to pass IMage or Video or Document
        templateType: this.template.header === 'text' ? 'TEXT' : this.template.header === 'none' ? 'TEXT' : this.template.media === 'image' ? 'IMAGE' : this.template.media === 'video' ? 'VIDEO' : this.template.media === 'document' ? 'DOCUMENT' : 'LOCATION',
        vertical: this.template.labels,
        content: this.convertHtmlToText(this.editorData),
        header: this.template.header === 'text' ? this.template.header_text : '',
        exampleHeader: this.template.header_text,
        footer: this.template.footer,
        example: this.generateSample(this.editorData),
        enableSample: this.template.header === 'media' ? true : false,
        allowTemplateCategoryChange: false,
        buttons: modifyButtons,
        mediaId: this.template.header === 'media' ? this.mediaId : '',
        variable_mapping: this.variableNames,
      };

      console.log('Payload to be sent:', payload);

      if (this.type === 'Edit') {



        this.api.updateTemplate(payload).subscribe({
          next: (res: any) => {
            this.formSubmit.emit();
          },
          error: (err: any) => {
            this.btnLoading = false;
            this.toastr.error('Failed to create template.', 'Error');
          },
          complete: () => {
            console.log('Template creation process completed.');
          }
        });
      } else {
        this.api.createTemplate(payload).subscribe({
          next: (res: any) => {
            this.formSubmit.emit();
          },
          error: (err: any) => {
            console.error('Error creating template:', err);
            this.btnLoading = false;
            this.toastr.error(err?.error || 'Failed to create template.', 'Error');
          },
          complete: () => {
            console.log('Template creation process completed.');
          }
        });
      }



      // Handle form submission, e.g., send data to the server
    } else {
      console.error('Form submission failed. Please correct the errors.');
    }
  }


  convertHtmlToText(html: string): string {
    if (!html) return '';

    let text = html;

    // contenteditable uses <div> for new lines — handle before anything else
    text = text.replace(/<div[^>]*><br\s*\/?><\/div>/gi, '\n');
    text = text.replace(/<\/div>\s*<div[^>]*>/gi, '\n');
    text = text.replace(/<div[^>]*>/gi, '\n');
    text = text.replace(/<\/div>/gi, '');

    // Convert <br> to newline
    text = text.replace(/<br\s*\/?>/gi, '\n');

    // Convert <p> to newline
    text = text.replace(/<\/p>/gi, '\n');
    text = text.replace(/<p[^>]*>/gi, '');

    // Bold — skip empty/whitespace-only inner content
    text = text.replace(/<(?:strong|b)[^>]*>([\s\S]*?)<\/(?:strong|b)>/gi, (_, inner) => {
      const t = inner.replace(/\n/g, '').trim();
      return t ? `*${t}*` : '';
    });

    // Italic
    text = text.replace(/<(?:em|i)[^>]*>([\s\S]*?)<\/(?:em|i)>/gi, (_, inner) => {
      const t = inner.replace(/\n/g, '').trim();
      return t ? `_${t}_` : '';
    });

    // Strikethrough
    text = text.replace(/<(?:s|strike|del)[^>]*>([\s\S]*?)<\/(?:s|strike|del)>/gi, (_, inner) => {
      const t = inner.replace(/\n/g, '').trim();
      return t ? `~${t}~` : '';
    });

    // Decode HTML entities
    text = text.replace(/&nbsp;/gi, ' ');
    text = text.replace(/&amp;/gi, '&');
    text = text.replace(/&lt;/gi, '<');
    text = text.replace(/&gt;/gi, '>');

    // Strip any remaining HTML tags
    text = text.replace(/<[^>]+>/g, '');

    // Normalize newlines
    text = text.replace(/\r/g, '');
    text = text.replace(/\n{3,}/g, '\n\n');

    return text.trim();
  }


  generateSample(html: string): string {
    if (!html) return '';

    // Reuse the same HTML→WhatsApp conversion, then substitute variables
    const plain = this.convertHtmlToText(html);

    return plain.replace(/{{\d+}}/g, match => {
      return `[${this.variables?.[match] || match}]`;
    });
  }

  isValidForm(): boolean {
    // Template names can only contain small letters, numbers and underscores.
    const templateNameValid = this.template.template_name !== '' &&
      /^[a-z0-9_]+$/.test(this.template.template_name);
    const categoryValid = this.template.category !== '';
    const languageValid = this.template.language !== '';
    const labelsValid = this.template.labels !== '';
    const headerValid = this.template.header !== '';
    const bodyValid = this.editorData !== '';

    const header_textValid = this.template.header === 'text' ? this.template.header_text !== '' : true;
    const mediaIdValid = this.template.header === 'media' ? this.mediaId !== '' : true;

    // checking for any variable empty or not 

    for (const variable in this.variables) {
      if (this.variables[variable] === '') {
        this.variableError = true;
        return false;
      }
    }


    // checking for value in on quick reply button

    if (this.quickReplyButtons.length > 0) {
      for (let i = 0; i < this.quickReplyButtons.length; i++) {
        if (this.quickReplyButtons[i].value === '') {
          this.toastr.error('Please enter value in quick reply button.', 'Error');
          return false;
        }
      }
    }

    // checking for value in on url button

    if (this.urlButtons.length > 0) {
      for (let i = 0; i < this.urlButtons.length; i++) {
        if (this.urlButtons[i].value === '' || this.urlButtons[i].title === '' || this.urlButtons[i].urlType === '') {
          this.toastr.error('Please enter value in url button.', 'Error');
          return false;
        }

        if (this.urlButtons[i].urlType === 'dynamic' && this.urlButtons[i].suffix === '') {
          this.toastr.error('Please enter suffix in url button.', 'Error');
          return false;
        }

        // check for value must be url
        if (this.urlButtons[i].urlType === 'static' && !this.urlButtons[i].value.includes('http')) {
          this.toastr.error('Please enter valid url in url button.', 'Error');
          return false;
        }

        if (this.urlButtons[i].urlType === 'dynamic' && !this.urlButtons[i].value.includes('http')) {
          this.toastr.error('Please enter valid url in url button.', 'Error');
          return false;
        }
      }
    }

    // checking for value in on call button

    if (this.callButtons.length > 0) {
      for (let i = 0; i < this.callButtons.length; i++) {
        if (this.callButtons[i].value === '' || this.callButtons[i].title === '') {
          this.toastr.error('Please enter value in call button.', 'Error');
          return false;
        }
      }
    }

    return templateNameValid && categoryValid && languageValid &&
      labelsValid && headerValid && bodyValid && header_textValid && mediaIdValid;
  }


  onFileChange(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    const acceptedFileTypes = this.acceptedFileTypes();
    if (!acceptedFileTypes.includes(file.type)) {
      this.toastr.error('Invalid file type. Please select a valid file type.', 'Error');
      return;
    }

    // Preview
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.template.mediaData = e.target.result;
      this.fileName = file.name;
    };
    reader.readAsDataURL(file);

    const clientId = this.localStorage.getHospitalId()
    this.uploadProgress = 0;

    // Upload with progress
    this.api.uploadFile(file, clientId).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.uploadProgress = Math.round(
            (event.loaded / event.total) * 100
          );

          if (this.uploadProgress === 100) {
            this.isProcessingMedia = true;
            this.uploadProgress = 99; // hold at 99%
          }
        }

        if (event.type === HttpEventType.Response) {
          if (event.body?.mediaId) {
            this.mediaId = event.body.mediaId;
            this.isProcessingMedia = false;
            this.uploadProgress = 100;
          }
        }
      },
      (error) => {
        this.uploadProgress = 0;
        this.toastr.error('Upload failed', 'Error');
        console.error(error);
      }
    );
  }



  removeMedia() {
    this.showMediaThroughMediaID = false;
    this.template.mediaData = '';
    this.mediaId = '';
    this.fileName = '';
  }

  closeModal() {
    this.close.emit();
  }


  maxFileSize(): number {
    switch (this.template.media) {
      case 'image':
        return 2 * 1024 * 1024; // 2 MB in bytes
      case 'video':
        return 20 * 1024 * 1024; // 20 MB in bytes
      case 'document':
        return 2 * 1024 * 1024; // 2 MB in bytes
      default:
        return 0;
    }
  }

  acceptedFileTypes(): string[] {
    switch (this.template.media) {
      case 'image':
        return ['image/jpeg', 'image/png']; // Specific MIME types for images
      case 'video':
        return ['video/mp4']; // Specific MIME types for videos
      case 'document':
        return ['application/pdf']; // MIME type for PDFs
      default:
        return [];
    }
  }


  selectMedia(mediaType: string) {
    this.template.media = mediaType;
    this.base64Data = '';
    this.template.mediaData = '';
  }

  saveSelection(): void {
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      if (this.editorElement && this.editorElement.nativeElement.contains(range.commonAncestorContainer)) {
        this.savedRange = range.cloneRange();
      }
    }
  }

  onEditorBlur(): void {
    this.saveSelection();
    this.syncEditorContent();
  }

  addVariable(event: any): void {
    event.preventDefault();
    this.variableCounter++;
    const newVariable = `{{${this.variableCounter}}}`;

    if (this.editorElement) {
      const editor = this.editorElement.nativeElement;

      editor.focus({ preventScroll: true });

      if (this.savedRange && editor.contains(this.savedRange.commonAncestorContainer)) {
        // Restore saved cursor position and insert there
        const selection = window.getSelection();
        if (selection) {
          selection.removeAllRanges();
          selection.addRange(this.savedRange);
          const variableNode = document.createTextNode(newVariable);
          this.savedRange.insertNode(variableNode);
          this.savedRange.setStartAfter(variableNode);
          this.savedRange.collapse(true);
          selection.removeAllRanges();
          selection.addRange(this.savedRange);
          this.savedRange = this.savedRange.cloneRange();
        }
      } else {
        // Cursor was outside editor — append variable at end
        const textNode = document.createTextNode(newVariable);
        editor.appendChild(textNode);
        const range = document.createRange();
        range.setStartAfter(textNode);
        range.collapse(true);
        const selection = window.getSelection();
        if (selection) {
          selection.removeAllRanges();
          selection.addRange(range);
        }
        this.savedRange = range.cloneRange();
      }

      this.syncEditorContent();
      this.extractVariables();
    }
  }


  onEditorChange(): void {

    this.initiaBody = false;
    if (this.editorData.length == 0) {
      this.variableCounter = 0;
      this.extractVariables();
      return;
    }

    const variablePattern = /\{\{\d+\}\}/g;
    const variablesInText = this.editorData.match(variablePattern);

    if (variablesInText) {
      const uniqueVariables = new Set(variablesInText);
      const variablesArray = Array.from(uniqueVariables);

      if (uniqueVariables.size < this.variableCounter) {
        let start = 1;

        // Loop through and replace all variables sequentially
        variablesArray.forEach((variable) => {
          const escapedVariable = variable.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special chars
          const variablePattern = new RegExp(escapedVariable, 'g');
          this.editorData = this.editorData.replace(variablePattern, `{{${start}}}`);
          start++;
        });

        // Update the variable counter
        this.variableCounter = start - 1;
      } else {
        this.variableCounter = uniqueVariables.size;
      }
    }

    this.extractVariables();
  }
  deleteVariable(key: string) {
    // Remove from variables list
    delete this.variables[key];
    delete this.variableNames[key];

    // Remove from editor content
    const escapedKey = key.replace(/[{}]/g, '\\$&');
    const regex = new RegExp(escapedKey, 'g');
    this.editorData = this.editorData.replace(regex, '');

    // Refresh variable list
    this.extractVariables();

    // Update preview
    this.updateRenderedData();

    // ✅ Update variableCounter from editor text
    const variablePattern = /\{\{\d+\}\}/g;
    const vars = this.editorData.match(variablePattern);
    this.variableCounter = vars ? vars.length : 0;
  }

  extractVariables(): void {
    const variablePattern = /\{\{\d+\}\}/g;
    const variablesInText = this.editorData.match(variablePattern);
    const uniqueVariables = new Set(variablesInText);

    // have to trim extra vratibles key which is not in uniqueVariables
    for (const variable in this.variables) {
      if (!uniqueVariables.has(variable)) {
        delete this.variables[variable];
        delete this.variableNames[variable];
      }
    }
    // ✅ Initialize missing variables safely
    uniqueVariables.forEach(variable => {
      if (this.variables[variable] === undefined) {
        this.variables[variable] = '';
      }

      if (this.variableNames[variable] === undefined) {
        this.variableNames[variable] = '';
      }
    });


    this.updateRenderedData();


  }

  // Update the rendered data when the sample value is changed
  updateRenderedData(): void {
    this.renderedData = this.editorData;
    for (const variable in this.variables) {
      const value = this.variables[variable] || ''; // Use empty string if no value is provided

      const escapedVariable = variable.replace(/[{}]/g, '\\$&'); // Escape the curly braces
      const regex = new RegExp(escapedVariable, 'g'); // Create a global regular expression
      this.renderedData = this.renderedData.replace(regex, value);
    }

    for (const variable in this.variables) {
      if (this.variables[variable] === '') {
        this.variableError = true;
        return;
      }
    }

    for (const variableName in this.variableNames) {
      if (this.variableNames[variableName] === '') {
        this.variableNameError = true;
        return;
      }
    }

    this.variableError = false;
    this.variableNameError = false;
  }

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }


  addQuickReplyButton(event: any): void {
    event.preventDefault();

    if (this.countQuickReplyButton + this.countCTAButtonForCall + this.countCTAButtonForURL > 10) {
      this.toastr.error('You can add maximum 10 buttons in a template.', 'Error');
      return
    }

    this.countQuickReplyButton++;

    this.quickReplyButtons.push({
      value: ''
    });

  }

  addUrlButton(event: any): void {

    if (this.countCTAButtonForURL > 1) {
      this.toastr.error('You can add maximum 2 Url Buttons in template', 'Error');
      return
    }

    event.preventDefault();
    this.countCTAButtonForURL++;
    this.urlButtons.push({
      value: '',
      title: '',
      urlType: '',
      suffix: '',
    });

  }

  addCallButton(event: any): void {
    event.preventDefault();


    if (this.countCTAButtonForCall > 0) {
      this.toastr.error('You can add maximum 1 CTA button in a template.', 'Error');
      return
    }

    this.countCTAButtonForCall++;
    this.callButtons.push({
      value: ''
    });
  }

  removeQuickReplyButton(event: any, index: any): void {
    event.preventDefault();
    this.countQuickReplyButton--;

    // remover perticular index from array
    this.quickReplyButtons.splice(index, 1);

  }

  removeUrlButton(event: any, index: any): void {
    event.preventDefault();
    this.countCTAButtonForURL--;
    this.urlButtons.splice(index, 1);
  }

  removeCallButton(event: any, index: any): void {
    event.preventDefault();
    this.countCTAButtonForCall--;
    this.callButtons.splice(index, 1);
  }

  showAllOptions() {
    this.showAllVariables = !this.showAllVariables;
  }

  // ===== CUSTOM EDITOR METHODS =====
  applyFormatting(format: string): void {
    if (!this.editorElement) return;
    
    const editor = this.editorElement.nativeElement;
    
    // Toggle the format state
    switch (format) {
      case 'bold':
        this.boldActive = !this.boldActive;
        document.execCommand('bold', false);
        break;
      case 'italic':
        this.italicActive = !this.italicActive;
        document.execCommand('italic', false);
        break;
      case 'strikethrough':
        this.strikethroughActive = !this.strikethroughActive;
        document.execCommand('strikeThrough', false);
        break;
    }

    // Ensure editor stays focused
    editor.focus();
    this.syncEditorContent();
  }

  clearFormatting(): void {
    if (!this.editorElement) return;
    
    const editor = this.editorElement.nativeElement;
    
    this.boldActive = false;
    this.italicActive = false;
    this.strikethroughActive = false;
    
    document.execCommand('removeFormat', false);
    document.execCommand('formatBlock', false, '<div>');
    
    editor.focus();
    this.syncEditorContent();
  }

  syncEditorContent(): void {
    if (!this.editorElement) return;
    
    const editor = this.editorElement.nativeElement;
    this.editorData = editor.innerHTML;
    this.onEditorChange();
  }

  onEditorInput(): void {
    this.syncEditorContent();
    // Update formatting states based on cursor position
    this.updateFormattingState();
  }

  // ===== AI GENERATION METHODS =====

  openAIGenerateModal(modal: any): void {
    this.aiGeneratePrompt = '';
    this.aiModalRef = this.modalService.open(modal, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'ai-generate-modal'
    });
  }

  confirmGenerateAI(): void {
    if (!this.aiGeneratePrompt || !this.aiGeneratePrompt.trim()) {
      this.toastr.warning('Please enter a prompt to generate content.');
      return;
    }

    this.isGeneratingAI = true;

    this.aiService.generateTemplate(this.aiGeneratePrompt.trim(), 'text', 'whatsapp').subscribe({
      next: (response: any) => {
        this.isGeneratingAI = false;

        if (response && response.content) {
          // Convert markdown formatting to HTML for display in editor
          const htmlContent = this.aiService.parseMarkdownToHtml(response.content);
          this.editorData = htmlContent;

          if (this.editorElement) {
            this.editorElement.nativeElement.innerHTML = htmlContent;
            this.syncEditorContent();
          }

          // Auto-close modal
          if (this.aiModalRef) {
            this.aiModalRef.close();
            this.aiModalRef = null;
          }

          this.toastr.success('Content generated successfully!');
        } else {
          this.toastr.error('Failed to generate content. No response received.');
        }
      },
      error: (error: any) => {
        this.isGeneratingAI = false;
        console.error('AI generation error:', error);
        this.toastr.error('Error generating content with AI. Please try again.');
      }
    });
  }

}

